import type { HTMLAttributes, ReactNode } from "react"

import { cn } from "@/domains/library"

import type { MessageBoxLayoutStrategy } from "../interfaces"

export const defaultLayoutStrategy: MessageBoxLayoutStrategy = {
  render(
    icon: ReactNode,
    content: ReactNode,
    containerClassName: string,
    props: HTMLAttributes<HTMLDivElement>,
  ): ReactNode {
    return (
      <div {...props} className={cn("flex flex-row items-center justify-between", containerClassName)}>
        <div className="flex w-12 flex-shrink-0 items-center justify-center">{icon}</div>
        <div className="flex-1">{content}</div>
      </div>
    )
  },
}

export const multilineLayoutStrategy: MessageBoxLayoutStrategy = {
  render(
    icon: ReactNode,
    content: ReactNode,
    containerClassName: string,
    props: HTMLAttributes<HTMLDivElement>,
  ): ReactNode {
    return (
      <div {...props} className={cn("flex flex-row items-start", containerClassName)}>
        <div className="flex w-6 flex-shrink-0 items-start justify-start pt-0.5">{icon}</div>
        <div className="flex-1">{content}</div>
      </div>
    )
  },
}
